import React,{useContext} from 'react';

import { List as MUIList, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction, IconButton, Slide } from '@material-ui/core';
import { Delete, MoneyOff } from '@material-ui/icons';
import { ExpenseTrackerContext } from '../../../../Context/Context';


import useStyles from'./Styles';



const List = () => {
    const classes =useStyles();
    const {deleteTransaction,transactions}=useContext(ExpenseTrackerContext);


  return (
  
    <MUIList dense={false} className={classes.list}>
        {transactions.map((transaction)=>  (
            <slide direction ="Down"   key={transaction.id}>

             <ListItem>

            <ListItemAvatar>
              <Avatar className={transaction.type === 'Income' ? classes.avatarIncome : classes.avatarExpense}>
                <MoneyOff />
              </Avatar>
            </ListItemAvatar>

            <ListItemText primary={transaction.category} secondary={`₹${transaction.amount} - ${transaction.date}`} />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete" onClick={()=>deleteTransaction(transaction.id)}>
                <Delete />
              </IconButton>
            </ListItemSecondaryAction>
            </ListItem>

            </slide>

        ))}
  
  </MUIList>


  );
};

export default List;